import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '@src/components/Tooltip';
import { checkVietNam } from '@src/utils/checkCountry';
import { PACKAGE_LEVEL } from '@src/constants/package';
import sanitizeHtml from 'sanitize-html';
import { LANGUAGE } from '@src/constants';
import { Typography } from '@mui/material';
import InfoVoucher from '../InfoVoucher';
import {
  TagVoucherContainer,
  TagVoucherImage,
  TagVoucherText,
  EmptyTag,
  PackageHeaderImage,
  PackageName,
  HeaderContainer,
} from './index.style';

const TagVoucher = ({ bestVoucher }) => {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const isVietNam = checkVietNam();

  if (bestVoucher?.id) {
    return (
      <TagVoucherContainer>
        <TagVoucherImage
          src="https://media-frontend.vbee.vn/images/package/voucher.webp"
          alt="voucher"
        />
        <TagVoucherText>
          <InfoVoucher
            bestVoucher={bestVoucher}
            isVietNam={isVietNam}
            language={language}
            newPricingOverviewEnabled
          />
        </TagVoucherText>
      </TagVoucherContainer>
    );
  }
  return <EmptyTag />;
};

const PackageHeader = ({
  data,
  inDiscountTime,
  bestVoucher,
  isApplyFirstPaidVoucher,
  hideDescription,
  comparisonMode,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const renderTitle = () => {
    if (data?.level === PACKAGE_LEVEL.CUSTOM) {
      return (
        <PackageHeaderImage
          src="https://media-frontend.vbee.vn/images/package/vip-plus-package-header.webp"
          alt="custom-package"
        />
      );
    }
    if (data?.level === PACKAGE_LEVEL.VIP) {
      return (
        <PackageHeaderImage
          src="https://media-frontend.vbee.vn/images/package/vip-package-header.webp"
          alt="vip-package"
        />
      );
    }
    return (
      <PackageName $inDiscountTime={inDiscountTime}>
        {data?.name?.[language]}
      </PackageName>
    );
  };

  return (
    <HeaderContainer comparisonMode={comparisonMode}>
      <div className="header-content">
        {renderTitle()}
        {bestVoucher && !isApplyFirstPaidVoucher && (
          <Tooltip arrow placement="top" title={t('bestVoucherApplied')}>
            <div>
              <TagVoucher bestVoucher={bestVoucher} />
            </div>
          </Tooltip>
        )}
      </div>
      {!hideDescription && (
        <Typography
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              language === LANGUAGE.VN
                ? data?.description?.[language]
                : data?.description?.[LANGUAGE.EN],
            ),
          }}
          className="description-package"
        />
      )}
    </HeaderContainer>
  );
};

export default PackageHeader;
